import React from "react";
import { T } from "../../app/tokens.js";
import { ViewKey } from "../../v2/components/ViewKey.jsx";

// Shared with the live compare marks, not the darker readout text palette.
export const SCENARIO_FILL_COLOR = {
  comfortable: T.green, tight: T.ragAmber, densify: T.teal, over: T.ragRed,
};
export const SCENARIO_MARKER_COLOR = { installed: T.dark, max: T.ragRed };

export function ScenarioViewKey({ policyBaseline }) {
  const density = policyBaseline?.densityFloorSfPerSeat;
  const densityLabel = typeof density === "number" && Number.isFinite(density) && density > 0
    ? `${density} sf / seat`
    : "policy density floor unavailable";
  return (
    <ViewKey
      testId="scenario-key"
      groups={[
        { label: "Seats vs capacity", items: [
          { label: "Comfortable", description: "under 90% of installed capacity", swatch: { kind: "bar", color: SCENARIO_FILL_COLOR.comfortable } },
          { label: "Tight", description: "at least 90% but under 100% of installed capacity", swatch: { kind: "bar", color: SCENARIO_FILL_COLOR.tight } },
          { label: "Densify", description: "at or above installed capacity and at or below the max-density ceiling, when headroom data exists", swatch: { kind: "bar", color: SCENARIO_FILL_COLOR.densify } },
          { label: "Over capacity", description: "above the max-density ceiling, or at/above installed capacity without headroom data", swatch: { kind: "bar", color: SCENARIO_FILL_COLOR.over } },
        ] },
        { label: "Markers", items: [
          { label: "Installed capacity", description: "seats installed today", swatch: { kind: "tick", color: SCENARIO_MARKER_COLOR.installed } },
          { label: "Max density", description: `seats at the policy density floor (${densityLabel})`, swatch: { kind: "tick", color: SCENARIO_MARKER_COLOR.max } },
        ] },
      ]}
      footer={<>
        <div>Scenario bars apply the controls on the right. Today uses current policy.</div>
        <div style={{ marginTop: 6 }}>Hypothetical demand overlays committed Plan without modifying it. Growth, days in office and sharing apply over horizon capacity; builds phase in and exits phase out on their dates. Reset to today clears the scenario.</div>
        <div style={{ marginTop: 6 }}>Densify requires max-capacity data. With headroom, the track ends at max density; otherwise it ends at installed capacity. Bars cap visually at the end. Zero capacity with no demand uses 0%. A non-finite percentage is Over capacity, except with headroom and a seat count not above a finite ceiling.</div>
      </>}
    />
  );
}
